"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SealLocationEnumToJSON = exports.SealLocationEnumFromJSONTyped = exports.SealLocationEnumFromJSON = exports.SealLocationEnum = void 0;
/**
 * The location of authenticity items such as a seal or signature. This is required for Birth Certificates.
 * @export
 * @enum {string}
 */
var SealLocationEnum;
(function (SealLocationEnum) {
    SealLocationEnum["FRONTCOLOR"] = "FRONT_COLOR";
    SealLocationEnum["FRONTRAISED"] = "FRONT_RAISED";
    SealLocationEnum["BACK"] = "BACK";
    SealLocationEnum["INVALIDVALUE"] = "_INVALID_VALUE";
})(SealLocationEnum = exports.SealLocationEnum || (exports.SealLocationEnum = {}));
function SealLocationEnumFromJSON(json) {
    return SealLocationEnumFromJSONTyped(json, false);
}
exports.SealLocationEnumFromJSON = SealLocationEnumFromJSON;
function SealLocationEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SealLocationEnumFromJSONTyped = SealLocationEnumFromJSONTyped;
function SealLocationEnumToJSON(value) {
    return value;
}
exports.SealLocationEnumToJSON = SealLocationEnumToJSON;
//# sourceMappingURL=SealLocationEnum.js.map